'use client'

/**
 * 团队卡片骨架加载组件
 */
export function TeamCardSkeleton() {
  return (
    <article className="bg-white rounded-lg overflow-hidden border border-gray-100">
      {/* Avatar Skeleton */}
      <div className="aspect-square bg-gray-200 animate-pulse" />

      {/* Content Area */}
      <div className="p-4">
        {/* Name Skeleton */}
        <div className="h-5 bg-gray-200 rounded animate-pulse mb-2" />
        <div className="h-5 bg-gray-200 rounded animate-pulse w-3/4 mb-3" />

        {/* Info Skeleton */}
        <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2 mb-4" />

        {/* Tags Skeleton */}
        <div className="flex gap-2">
          <div className="h-6 w-16 bg-gray-200 rounded animate-pulse" />
          <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" />
          <div className="h-6 w-24 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    </article>
  )
}
